module.exports = __webpack_public_path__ + "static/media/icon-reanimacao.b59872df.svg";